import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-radiobox',
  imports: [],
  templateUrl: './radiobox.html',
  styles: ``,
})
export class Radiobox {
  @Input() checked: boolean = false;
  @Input() label: string = '';
  @Input() displayDirection: string = 'horizontal'; // horizontal | vertical

}
